export default [
    {
        path: '/relatorios/rel-participacoes',
        view: 'relatorio-participacoes/RelParticipacoes',
        name: 'Relatório de Participações',
        permissions: ['ADMINISTRADOR', 'GESTOR', 'AUDITOR', 'COMISSAO_PROPRIA', 'COMISSAO_SETORIAL'],
        breadcrumbs: [
            {
                text: 'Relatórios',
                disabled: false,
                exact: true,
                to: '/dashboard',
            },
            {
                text: 'Participacões',
                disabled: true,
                exact: true,
                to: '/relatorios/rel-participacoes',
            },
        ],
    },
    {
        path: '/relatorios/acompanhamento',
        view: 'relatorio-acompanhamento/Index',
        name: 'Relatório de Acompanhamento da Avaliação',
        permissions: null, // Relatório público
        breadcrumbs: [
            {
                text: 'Relatórios',
                disabled: false,
                exact: true,
                to: '/dashboard',
            },
            {
                text: 'Acompanhamento',
                disabled: true,
                exact: true,
                to: '/relatorios/acompanhamento',
            },
        ],
    },
    {
        path: '/relatorios/resultados/questoes-discursivas',
        view: 'relatorio-resultados/RelResultadosQuestoesDescritivas',
        name: 'Relatório de Resultados - Questões Discursivas',
        permissions: ['ADMINISTRADOR', 'GESTOR', 'AUDITOR', 'COORDENADOR', 'COMISSAO_PROPRIA', 'COMISSAO_SETORIAL', 'GESTOR_SETORIAL', 'DOCENTE'],
        breadcrumbs: [
            {
                text: 'Relatórios',
                disabled: false,
                exact: true,
                to: '/dashboard',
            },
            {
                text: 'Relatório de Resultados - Questões Discursivas',
                disabled: true,
                exact: true,
                to: '/relatorios/resultados/questoes-discursivas',
            },
        ],
    },
    {
        path: '/relatorios/resultados/questoes-objetivas',
        view: 'relatorio-resultados/RelResultadosQuestoesObjetivas',
        name: 'Relatório de Resultados - Questões Objetivas',
        permissions: [
            'ADMINISTRADOR',
            'AUDITOR',
            'GESTOR',
            'COORDENADOR',
            'COMISSAO_PROPRIA',
            'COMISSAO_SETORIAL',
            'DOCENTE',
            'GESTOR_SETORIAL',
            'COMISSAO_PROPRIA_ALUNO',
            'COMISSAO_SETORIAL_ALUNO'
        ],
        breadcrumbs: [
            {
                text: 'Relatórios',
                disabled: false,
                exact: true,
                to: '/dashboard',
            },
            {
                text: 'Relatório de Resultados - Questões Objetivas',
                disabled: true,
                exact: true,
                to: '/relatorios/resultados/questoes-objetivas',
            },
        ],
    },
    {
        path: '/relatorios/relatorio-acoes',
        view: 'relatorio-resultados/RelatorioAcoes',
        name: 'Relatório de Ações',
        permissions: [
            'ADMINISTRADOR',
            'AUDITOR',
            'GESTOR',
            'COORDENADOR',
            'COMISSAO_PROPRIA',
            'COMISSAO_SETORIAL',
        ],
        breadcrumbs: [
            {
                text: 'Relatórios',
                disabled: false,
                exact: true,
                to: '/dashboard',
            },
            {
                text: 'Relatório de Ações',
                disabled: true,
                exact: true,
                to: '/relatorios/relatorio-acoes',
            },
        ],
    },
    {
        path: '/relatorios/analise-temporal',
        view: 'analise-temporal/Index',
        name: 'Relatório de Análise Temporal',
        permissions: [
            'ADMINISTRADOR',
            'AUDITOR',
            'GESTOR',
            'COORDENADOR',
            'COMISSAO_PROPRIA',
            'COMISSAO_SETORIAL',
        ],
        breadcrumbs: [
            {
                text: 'Relatórios',
                disabled: false,
                exact: true,
                to: '/dashboard',
            },
            {
                text: 'Relatório de Análise Temporal',
                disabled: true,
                exact: true,
                to: '/relatorios/analise-temporal',
            },
        ],
    },
    {
        path: '/relatorios/exportacao-respostas-descritivas',
        view: 'exportacao-respostas-descritivas/Index',
        name: 'Exportar Respostas Descritivas',
        permissions: [
            'ADMINISTRADOR',
            'GESTOR',
            'COMISSAO_PROPRIA',
        ],
        breadcrumbs: [
            {
                text: 'Relatórios',
                disabled: false,
                exact: true,
                to: '/dashboard',
            },
            {
                text: 'Exportar Respostas Descritivas',
                disabled: true,
                exact: true,
                to: '/relatorios/exportacao-respostas-descritivas',
            },
        ],
    }
];
